import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { MenuApiService } from '../../services/menu/menu-api.service';
import { mapApiMenuTreeToPrimeMenu } from '../../utility/menu-to-primeng';
import { MENU_STATE_DEFAULTS, MenuStateModel } from './menu-state-model';
import { LoadPortalMenus, SetPortalMenuBar } from './menu.actions';

@State<MenuStateModel>({
  name: 'menu',
  defaults: MENU_STATE_DEFAULTS,
})
@Injectable()
export class MenuState {
  constructor(private readonly menuApi: MenuApiService) {}

  @Action(LoadPortalMenus)
  loadPortalMenus(ctx: StateContext<MenuStateModel>) {
    return this.menuApi.getMyMenus().pipe(
      tap((res) => {
        const tree = (res as { result?: unknown })?.result;
        const items = Array.isArray(tree) ? mapApiMenuTreeToPrimeMenu(tree as never[]) : [];
        ctx.patchState({ barItems: items, loaded: true });
      }),
      catchError(() => {
        ctx.patchState({ barItems: [], loaded: true });
        return of(null);
      })
    );
  }

  @Action(SetPortalMenuBar)
  setBar(ctx: StateContext<MenuStateModel>, action: SetPortalMenuBar) {
    ctx.patchState({ barItems: action.items, loaded: true });
  }
}
